import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Select } from "semantic-ui-react";
import useAuthority from "../../hooks/useAuthority";
import useFieldVisibility from "../../hooks/useFieldVisibility";

const Dropdown = forwardRef(
  (
    {
      error,
      options,
      label,
      value,
      onChange = () => {},
      placeholder,
      resetError = () => {},
      required = false,
      style = { height: "5px" },
      clearable = true,
      readOnly = false,
      disabled = false,
      search = false,
      module = "",
      form = "",
      field = "",
      editMode,
      authenticated,
      needDeletePermission = false,
      useDynamicFields = false,
      ...props
    },
    ref,
  ) => {
    const [touched, setTouched] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    const { view, authorized } = useAuthority({
      module,
      form,
      field,
      editMode,
      authenticated,
      needDeletePermission,
    });

    const {
      visible,
      mandatory,
      label: currentLabel,
    } = useFieldVisibility({ field, useDynamicFields, form });

    useEffect(() => {
      setCurrentValue(value);
    }, [value]);

    useImperativeHandle(ref, () => ({
      value: currentValue,
      reset: () => setCurrentValue(""),
    }));

    if (useDynamicFields && !visible) {
      return;
    }

    return (
      <>
        <style>
          {`
            .custom-dropdown .menu {
              max-height: 150px !important; 
              overflow-y: auto !important;
            }
          `}
        </style>
        <div className={`field ${error ? "error" : ""}`}>
          <label
            style={
              view
                ? useDynamicFields
                  ? visible
                    ? {}
                    : { display: "none" }
                  : {}
                : { display: "none" }
            }
          >
            {((useDynamicFields && mandatory) ||
              (!useDynamicFields && required)) && (
              <label
                style={{
                  color: "#9f3a38",
                  fontSize: "20px",
                  marginRight: "2px",
                }}
              >
                *
              </label>
            )}
            {useDynamicFields ? currentLabel : label}
          </label>
          <Select
            selectOnBlur={false}
            {...props}
            className="custom-dropdown"
            search={search}
            disabled={readOnly || disabled || !authorized}
            clearable={clearable}
            placeholder={placeholder}
            options={options}
            value={currentValue}
            style={
              view
                ? useDynamicFields
                  ? visible
                    ? style
                      ? { ...style }
                      : {}
                    : { display: "none" }
                  : style
                    ? { ...style }
                    : {}
                : { display: "none" }
            }
            onChange={(e, data) => {
              onChange(e, data);
              setCurrentValue(data.value);
            }}
            onClick={() => {
              setTouched(true);
              if (error) {
                resetError();
              }
            }}
          />
          <small style={{ color: "#9f3a38" }}>{`${error ? error : ""}`}</small>
        </div>
      </>
    );
  },
);

export default Dropdown;
